module.exports = __webpack_public_path__ + "static/media/Step3.ad044a2a.jpg";